var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnionBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6505 0.123618C9.86477 -0.041206 10.135 -0.041206 10.3493 0.123618L19.016 6.79028C19.27 6.98568 19.3893 7.36821 19.308 7.72695C19.2268 8.08569 18.9648 8.33333 18.6666 8.33333H16.6663V15H18.0002C18.3684 15 18.6669 15.3731 18.6669 15.8333C18.6669 16.2936 18.3684 16.6667 18.0002 16.6667H2.00021C1.63202 16.6667 1.33354 16.2936 1.33354 15.8333C1.33354 15.3731 1.63202 15 2.00021 15H3.33344V8.33333H1.33323C1.03496 8.33333 0.772991 8.08569 0.691761 7.72695C0.61053 7.36821 0.72981 6.98568 0.983829 6.79028L9.6505 0.123618ZM15.3329 8.33333V15H12.6669V8.33333H15.3329ZM11.3335 8.33333V15H8.6664V8.33333H11.3335ZM7.33307 8.33333V15H4.66677V8.33333H7.33307ZM16.0206 6.66667C16.0137 6.6664 16.0066 6.66626 15.9996 6.66626C15.9926 6.66626 15.9856 6.6664 15.9786 6.66667H12.0212L12.0129 6.66641L12.0002 6.66626C11.9932 6.66626 11.9862 6.6664 11.9792 6.66667H8.02075C8.01377 6.6664 8.00677 6.66626 7.99974 6.66626C7.9927 6.66626 7.9857 6.6664 7.97872 6.66667H4.02112C4.01414 6.6664 4.00713 6.66626 4.0001 6.66626C3.99307 6.66626 3.98606 6.6664 3.97908 6.66667H3.68859L9.99989 1.81182L16.3112 6.66667H16.0206ZM0.666667 18.3337C0.298477 18.3337 0 18.7068 0 19.1671C0 19.6273 0.298477 20.0004 0.666667 20.0004H19.3333C19.7015 20.0004 20 19.6273 20 19.1671C20 18.7068 19.7015 18.3337 19.3333 18.3337H0.666667Z",
    fill: "#192851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionBlack);
export default __webpack_public_path__ + "static/media/union-black.057724d0c7264b7567ba33204e11c1d2.svg";
export { ForwardRef as ReactComponent };